// extracted by mini-css-extract-plugin
export default {"auth":"Auth_auth__dQR6-","main":"Auth_main__L1qw2","text":"Auth_text__3HxYS","phoneNum":"Auth_phoneNum__6bHnw","error":"Auth_error__OTmE6"};